/** DPL Gift With Purchase. Optional enhancement; never intercepts checkout. */
(() => {
  'use strict';
  const CONFIG = Object.freeze({
    enabled: true,
    startDate: '2026-10-20T19:00:00-05:00',
    endDate: '2026-11-03T00:00:00-06:00', // exclusive; covers all Nov 2
    minimumSpend: 15000, // $150, cents
    giftVariantId: 46312540536972,
    giftProperty: '_dpl_gwp',
    giftPropertyValue: 'clinical-xl-2026',
  });

  const root = window.Shopify?.routes?.root || '/';
  const url = (path) => `${root}${path}`;
  const isGift = (item) => Number(item.variant_id) === CONFIG.giftVariantId &&
    item.properties?.[CONFIG.giftProperty] === CONFIG.giftPropertyValue;
  const active = () => CONFIG.enabled &&
    Date.now() >= Date.parse(CONFIG.startDate) &&
    Date.now() < Date.parse(CONFIG.endDate);
  const suppressionKey = 'dpl_gwp_removed_2026';
  let busy = false;
  let queued = false;
  let lastGiftPresent = false;
  let initialized = false;

  async function request(path, options) {
    const response = await fetch(url(path), { credentials: 'same-origin', ...options });
    if (!response.ok) throw new Error(`GWP cart request failed: ${response.status}`);
    return response.json();
  }

  async function changeGift(item, quantity) {
    return request('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity })
    });
  }

  function refreshUI() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    // The full cart page has its own rendering; reload only after our own mutation.
    if (location.pathname.replace(/\/$/, '') === '/cart') location.reload();
  }

  async function reconcile() {
    if (busy) { queued = true; return; }
    busy = true;
    try {
      const cart = await request('cart.js');
      const gifts = cart.items.filter(isGift);
      if (initialized && lastGiftPresent && !gifts.length && active()) {
        try { sessionStorage.setItem(suppressionKey, '1'); } catch (_) { /* optional */ }
      }
      initialized = true;
      lastGiftPresent = gifts.length > 0;

      // Qualifying amount excludes any promotional gift, even if not discounted yet.
      const eligibleCents = cart.items.reduce((sum, item) =>
        sum + (isGift(item) ? 0 : item.final_line_price), 0);
      const qualifies = active() && eligibleCents >= CONFIG.minimumSpend;
      let suppressed = false;
      try { suppressed = sessionStorage.getItem(suppressionKey) === '1'; } catch (_) { /* optional */ }

      if (!qualifies) {
        // Only remove gift lines added by this script, never purchased Clinical XL.
        for (const gift of gifts) await changeGift(gift, 0);
        if (gifts.length) { lastGiftPresent = false; refreshUI(); }
        // Reset opt-out after customer becomes ineligible.
        if (eligibleCents < CONFIG.minimumSpend) {
          try { sessionStorage.removeItem(suppressionKey); } catch (_) { /* optional */ }
        }
      } else if (gifts.length > 1 || (gifts.length === 1 && gifts[0].quantity > 1)) {
        // One promotional unit maximum.
        for (const extra of gifts.slice(1)) await changeGift(extra, 0);
        if (gifts[0].quantity > 1) await changeGift(gifts[0], 1);
        refreshUI();
      } else if (!gifts.length && !suppressed) {
        await request('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{
            id: CONFIG.giftVariantId,
            quantity: 1,
            properties: { [CONFIG.giftProperty]: CONFIG.giftPropertyValue }
          }] })
        });
        lastGiftPresent = true;
        refreshUI();
      }
    } catch (error) {
      // GWP must never prevent normal cart interactions or checkout.
      console.warn('[DPL GWP] Optional gift automation skipped:', error);
    } finally {
      busy = false;
      if (queued) { queued = false; queueMicrotask(reconcile); }
    }
  }

  let debounceTimer;
  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reconcile, 250);
  }
  document.addEventListener('on:cart:add', schedule);
  document.addEventListener('on:line-item:change', schedule);
  document.addEventListener('on:cart:discount-added', schedule);
  window.addEventListener('pageshow', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
